import React from 'react'
import { SvgIconProps } from './Home'

const SvgReportsIcon = ({ fill }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="17"
    fill="none"
    viewBox="0 0 19 17"
  >
    <path
      fill={fill ?? "#353535"}
      d="M18.11 15.21h-.198V3.778C18.604 3.48 19 2.784 19 1.988 19 .895 18.11 0 17.022 0a1.989 1.989 0 00-1.978 1.988c0 .2 0 .398.1.597L12.67 4.87c-.198-.1-.495-.1-.693-.1-.593 0-1.186.3-1.582.796L8.913 5.17c-.198-.895-.99-1.591-1.88-1.591a1.989 1.989 0 00-1.977 1.988c0 .2 0 .497.099.696L2.682 8.848c-.296-.1-.494-.1-.692-.1-.692 0-1.286.299-1.681.895-.594.895-.297 2.187.593 2.784.099 0 .198.1.198.1v2.684H.902a.889.889 0 00-.89.894c0 .497.396.895.89.895H18.11c.494 0 .89-.398.89-.895a.889.889 0 00-.89-.895zm-4.154-8.847c0-.1 0-.1-.099-.2l2.275-2.186V15.21h-3.264V8.55c.792-.398 1.286-1.293 1.088-2.187zM11.088 8.55v6.66H7.825V7.457c.296-.199.593-.398.692-.596l1.484.298a2.57 2.57 0 001.087 1.392zm-7.12 1.79c0-.1 0-.2-.1-.3l2.276-2.286v7.457H2.88v-2.685c.791-.397 1.286-1.292 1.088-2.187z"
    ></path>
  </svg>
)


export default SvgReportsIcon